import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { VoceFeed } from "@/types/api";

interface UseFeedOptions {
  limit?: number;
  offset?: number;
}

export function useFeed({ limit = 20, offset = 0 }: UseFeedOptions = {}) {
  return useQuery({
    queryKey: ["feed", { limit, offset }],
    queryFn: () =>
      apiFetch<VoceFeed[]>(`/api/v1/feed?limit=${limit}&offset=${offset}`),
    staleTime: 60_000,
  });
}
